export default __webpack_public_path__ + "static/media/what_in_the_hot_crispy_kentucky_fried_fuck.af34eb78.png";